// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4723":"59f062c490","5894":"14a0da6830"}[chunkId] + ".chunk.css";
};